import { useEffect, useState } from 'react';
import { upcomingEvent as defaultEvent } from '../mock';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetches the admin-editable upcoming event from the API on mount.
 * Falls back to the bundled defaults (mock.js) if the API is unreachable
 * or hasn't been seeded yet.
 *
 * `refresh()` is exposed so the admin editor can force a re-fetch after
 * saving without a full page reload.
 */
export const useUpcomingEvent = () => {
  const [event, setEvent] = useState(defaultEvent);
  const [loaded, setLoaded] = useState(false);

  const fetchEvent = async () => {
    try {
      const res = await fetch(`${API_URL}/api/event/upcoming`);
      if (!res.ok) throw new Error(`status ${res.status}`);
      const data = await res.json();
      if (data && data.event) {
        setEvent({ ...defaultEvent, ...data.event });
      }
    } catch {
      /* silently fall back to bundled defaults */
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    fetchEvent();
  }, []);

  return { event, loaded, refresh: fetchEvent };
};

export default useUpcomingEvent;
